export function getInitials(name: string, maxLength: number = 2) {
  if (!name) return "";

  const words = name.trim().split(/\s+/).filter(Boolean);
  if (words.length === 0) return "";

  const getGraphemes = (str: string) => {
    return Array.from(str);
  };

  if (words.length > 1) {
    return words
      .slice(0, maxLength)
      .map((word) => getGraphemes(word)[0])
      .join("")
      .toLocaleUpperCase();
  }

  // Single word: take up to maxLength characters
  return getGraphemes(words[0])
    .slice(0, maxLength)
    .join("")
    .toLocaleUpperCase();
}
